import React from "react";
import * as Styled from "./styles";
import { useClinicalBudget } from "shared/providers/ClinicalBudget";
import { IoClose } from "react-icons/io5";

const BudgetFacesModal: React.FC = () => {
  const {
    showFacesModal,
    setShowFacesModal,
    pendingToothForFaces,
    setPendingToothForFaces,
    selectedProc,
    effectiveQtdFaces,
    setFacesPorElemento,
    setSelectedTeeth,
    selectedArea,
    selectedValor,
    selectedCategoria,
    selectedCatprocId,
    addItem,
    setShowOdontograma,
    setSelectedProc,
    setSelectedCategoria,
    setSelectedGrupo,
    facesRef,
  } = useClinicalBudget();

  const [selectedFaces, setSelectedFaces] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (showFacesModal) {
      setSelectedFaces([]);
    }
  }, [showFacesModal]);

  if (!showFacesModal || pendingToothForFaces === null || !selectedProc) return null;

  const maxFaces = effectiveQtdFaces;
  const isNaoSeAplica = pendingToothForFaces === 0;

  const handleToggleFace = (sigla: string) => {
    setSelectedFaces(prev => {
      if (prev.includes(sigla)) {
        return prev.filter(f => f !== sigla);
      }
      if (prev.length >= maxFaces) {
        return prev;
      }
      return [...prev, sigla];
    });
  };

  const handleClose = () => {
    setShowFacesModal(false);
    setPendingToothForFaces(null);
  };

  const handleConfirm = () => {
    if (selectedFaces.length !== maxFaces) return;

    const facesStr = selectedFaces.join(',');

    if (isNaoSeAplica) {
      addItem({
        procId: selectedProc.id,
        procNome: selectedProc.nome,
        area: selectedArea,
        elemento: 0,
        valor: selectedValor || selectedProc.valor,
        grupoId: 0,
        grupoNome: selectedCategoria?.nome ?? '',
        qtde: 1,
        faces: facesStr,
        catprocId: selectedCatprocId || 0,
        gpitemId: 0,
        obsPersonalizado: '',
      });

      setShowFacesModal(false);
      setShowOdontograma(false);
      setSelectedTeeth([]);
      setFacesPorElemento({});
      setSelectedProc(null);
      setSelectedCategoria(null);
      setSelectedGrupo(null);
      setPendingToothForFaces(null);
    } else {
      setFacesPorElemento(prev => ({
        ...prev,
        [String(pendingToothForFaces)]: facesStr,
      }));
      setSelectedTeeth(prev => {
        if (prev.includes(pendingToothForFaces!)) return prev;
        return [...prev, pendingToothForFaces!];
      });
      setShowFacesModal(false);
      setPendingToothForFaces(null);
    }
  };

  const isFaceDisabled = (sigla: string) => {
    return selectedFaces.length >= maxFaces && !selectedFaces.includes(sigla);
  };

  return (
    <Styled.ModalOverlay onClick={handleClose}>
      <Styled.ModalContent onClick={e => e.stopPropagation()}>
        <Styled.ModalHeader>
          <Styled.CloseButton onClick={handleClose}>
            <IoClose size={24} />
          </Styled.CloseButton>
          <h3>Selecionar Faces</h3>
          <p>{selectedProc.nome}</p>
          <p>Elemento: {isNaoSeAplica ? 'N/A' : pendingToothForFaces}</p>
        </Styled.ModalHeader>

        <Styled.ModalBody>
          <Styled.InfoText>
            Selecione <strong>{maxFaces}</strong> face(s)
          </Styled.InfoText>

          <Styled.FacesGrid>
            {facesRef.map(face => (
              <Styled.FaceButton
                key={face.sigla}
                selected={selectedFaces.includes(face.sigla)}
                disabled={isFaceDisabled(face.sigla)}
                onClick={() => handleToggleFace(face.sigla)}
              >
                {face.sigla}
                <small>{face.descricao}</small>
              </Styled.FaceButton>
            ))}
          </Styled.FacesGrid>

          <Styled.SelectedList>
            {selectedFaces.length > 0 ? selectedFaces.join(', ') : 'Nenhuma'}
          </Styled.SelectedList>
        </Styled.ModalBody>

        <Styled.ModalFooter>
          <Styled.FooterButton variant="secondary" onClick={handleClose}>
            Cancelar
          </Styled.FooterButton>
          <Styled.FooterButton
            variant="primary"
            onClick={handleConfirm}
            disabled={selectedFaces.length !== maxFaces}
          >
            Confirmar
          </Styled.FooterButton>
        </Styled.ModalFooter>
      </Styled.ModalContent>
    </Styled.ModalOverlay>
  );
};

export { BudgetFacesModal };
